import {Empty, Input, Menu} from 'antd';
import {FileAddOutlined} from '@ant-design/icons';
import React, {useEffect, useRef} from 'react';

const {Search} = Input;
const {SubMenu} = Menu;

export function TemplatesMenu({
  searchText,
  filteredTemplates,
  filterTemplates,
  inputTemplate,
  createTemplate,
  onClose,
  className,
  inputMessage,
}) {
  const templatesRef = useRef(null);

  useEffect(() => {
    const closeMenu = function (e) {
      if (
        !templatesRef.current?.contains(e.target) &&
        typeof e.target.className === 'string' &&
        !e.target.className.includes(className)
      ) {
        onClose();
      }
    };

    window.addEventListener('click', closeMenu);

    return () => {
      window.removeEventListener('click', closeMenu);
    };
  }, []);

  const grouped: Record<string, any[]> = {};
  const ungrouped: any[] = [];

  if (filteredTemplates) {
    filteredTemplates.forEach((t: any) => {
      if (t.group) {
        if (!grouped[t.group]) grouped[t.group] = [];
        grouped[t.group].push(t);
      } else {
        ungrouped.push(t);
      }
    });
  }

  const hasTemplates = filteredTemplates && filteredTemplates.length > 0;
  const hasGroups = Object.keys(grouped).length > 0;

  return (
    <div ref={templatesRef}>
      <Search className={className} onChange={event => filterTemplates(event.target.value)} value={searchText} />
      {createTemplate && (
        <Menu
          onClick={() => {
            onClose();
            createTemplate();
          }}
        >
          <Menu.Item key={'new'}>
            <FileAddOutlined /> {inputMessage ? 'Save as New Template' : 'New Template'}
          </Menu.Item>
        </Menu>
      )}
      {hasTemplates && (
        <Menu onClick={inputTemplate} mode="inline">
          {Object.entries(grouped).map(([group, templates]) => (
            <SubMenu key={`group-${group}`} title={group}>
              {templates.map((t: any) => (
                <Menu.Item key={t.id}>{t.title}</Menu.Item>
              ))}
            </SubMenu>
          ))}
          {hasGroups && ungrouped.length > 0 && <Menu.Divider />}
          {ungrouped.map((t: any) => (
            <Menu.Item key={t.id}>{t.title}</Menu.Item>
          ))}
        </Menu>
      )}
      {!hasTemplates && (
        <div style={{background: '#fff'}}>
          <Empty />
        </div>
      )}
    </div>
  );
}